import React from "react";
import { ConfirmationContextType } from "../types/confirmation-context-type";

export const ConfirmationContext = React.createContext<ConfirmationContextType>({
    confirm: () => { throw new Error('No Confirmation Provider'); },
    addConfirmation: () => { throw new Error('No Confirmation Provider'); },
});


